
(function () {

  /* ---------- Helpers ---------- */
  function extractDaysFromText(text) {
  if (!text) return null;

  // Detect language
  const lang = document.documentElement.lang || 'fr'; // default to fr
  let regex;

  if (lang.startsWith('fr')) {
    // Match "20 jours", "30 jours", etc.
    regex = /(\d+)\s*jours?/i;
  } else {
    // Default English: "20 days", "10 days"
    regex = /(\d+)\s*days?/i;
  }

  const match = text.match(regex);
  return match ? parseInt(match[1], 10) : null;
}


  function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  function format(date) {
    // Use page language or default to French
    const lang = 'fr-FR'; // force DD/MM format
    return date.toLocaleDateString(lang, {
      day: '2-digit',
      month: '2-digit'
    });
  }

  /* ---------- Get "Délais" / "Delivery" value ---------- */
  function getDelaisValue() {
    // Select-based themes
    const selects = document.querySelectorAll('select[name^="options"]');
    for (const select of selects) {
      const label = select.closest('div, fieldset')?.querySelector('label');
      if (label && /(délais|delivery)/i.test(label.textContent)) {
        return select.options[select.selectedIndex].text;
      }
    }

    // Radio-based themes
    const radios = document.querySelectorAll('input[type="radio"]:checked');
    for (const radio of radios) {
      const label = document.querySelector(`label[for="${radio.id}"]`);
      if (label && /(jours|days)/i.test(label.textContent)) {
        return label.textContent;
      }
    }

    return null;
  }

  /* ---------- Update "Prête à l'envoi" / "Ready to ship" ---------- */
  /* ---------- Update "Prête à l'envoi" / "Ready to ship" ---------- */
function updateReadyToShip() {
  const readyBlock = document.querySelector('.order-ready-content-box__step-box');
  if (!readyBlock) return;

  const dateSpan = readyBlock.querySelector('.date__sub-content > span');
  if (!dateSpan) return;

  const delaisText = getDelaisValue()?.toLowerCase() || '';
  const days = extractDaysFromText(delaisText);
  const today = new Date();

  let start, end;

  // Specific known durations
  if (delaisText.includes('20')) {
    start = addDays(today, 15);
    end = addDays(today, 20);
  } else if (delaisText.includes('10')) {
    start = addDays(today, 10);
    end = addDays(today, 10);
  } else if (delaisText.includes('30')) {
    start = addDays(today, 25);
    end = addDays(today, 30);
  }
  // Any other number of days → last 5 days of the total
  else if (days && !isNaN(days)) {
    start = addDays(today, Math.max(days - 5, 0));
    end = addDays(today, days);
  }
  // Fallback if no value found
  else {
    start = addDays(today, 3);
    end = addDays(today, 7);
  }

  // Save for delivery date
  window._readyEndDate = end;

  const sameDate = format(start) === format(end);
  const displayDate = sameDate ? format(end) : `${format(start)} - ${format(end)}`;

  const lang = document.documentElement.lang?.toLowerCase() || 'fr';
  const tooltip = lang.startsWith('en')
    ? sameDate
      ? `Order estimated ready to ship on ${format(end)}`
      : `Order estimated ready to ship between ${format(start)} and ${format(end)}`
    : sameDate
      ? `Commande prête à l’envoi estimée le ${format(end)}`
      : `Commande prête à l’envoi estimée entre ${format(start)} et ${format(end)}`;

  dateSpan.innerHTML = `
    ${displayDate}
    <p style="color:#fff;background:#000;font-size:14px;">
      ${tooltip}
    </p>
  `;
}

/* ---------- Update "Livrée!" / "Delivered" ---------- */
function updateDeliveredDate() {
  const deliveredBlock = document.querySelector('.order-delivered-content-box__step-box');
  if (!deliveredBlock) return;

  const dateSpan = deliveredBlock.querySelector('.date__sub-content > span');
  if (!dateSpan) return;

  const readyEndDate = window._readyEndDate || new Date();
  const deliveryDate = addBusinessDays(readyEndDate, 4);

  const lang = document.documentElement.lang?.toLowerCase() || 'fr';
  const tooltip = lang.startsWith('en')
    ? `Estimated delivery on ${format(deliveryDate)}`
    : `Estimation de livraison le ${format(deliveryDate)}`;

  dateSpan.innerHTML = `
    ${format(deliveryDate)}
    <p style="color:#fff;background:#000;font-size:14px;">
      ${tooltip}
    </p>
  `;
}




  /* ---------- Helper: add only business days ---------- */
  function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) { // skip weekends
        added++;
      }
    }
    return result;
  }


  /* ---------- Global update ---------- */
  function updateAllDates() {
    updateReadyToShip();
    updateDeliveredDate();
  }

  /* ---------- Listen to option changes ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('select[name^="options"]') || e.target.matches('input[type="radio"]')) {
      updateAllDates();
    }
  });

  /* ---------- Initial load (wait for widget) ---------- */
  const observer = new MutationObserver(() => {
    if (
      document.querySelector('.order-ready-content-box__step-box') &&
      document.querySelector('.order-delivered-content-box__step-box')
    ) {
      observer.disconnect();
      updateAllDates();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();